/**
 * Generated runtime TestId mirror for frontend/src/features/outbound-connectors/components/forms/RestConfigCard.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const RestConfigCardTestIds = {
  btnCreateRestConfig: "btn-create-rest-config",
  btnEditRestConfig: "btn-edit-rest-config",
  cardTitleRestConfig: "card-title-rest-config",
  restAuthSecretRef: "rest-auth-secret-ref",
  restConfigCard: "rest-config-card",
  restGrantHeadersDisplay: "rest-grant-headers-display",
  restRevokeHeadersDisplay: "rest-revoke-headers-display",
  selectRestAuthType: "select-rest-auth-type",
  selectRestGrantMethod: "select-rest-grant-method",
  selectRestRevokeMethod: "select-rest-revoke-method"
} as const;
